import thirtySTM from '../media/images/avatars/30stm.png';
import evanescence from '../media/images/avatars/evanescence.png';
import fresno from '../media/images/avatars/fresno.png';
import lp from '../media/images/avatars/lp.png';
import mcr from '../media/images/avatars/mcr.png';
import nxZero from '../media/images/avatars/nxZero.png';
import paramore from '../media/images/avatars/paramore.png';
import simplePlan from '../media/images/avatars/simplePlan.png';
import theStrokes from '../media/images/avatars/theStrokes.png';
import theUsed from '../media/images/avatars/theUsed.png';

const avatars = [
  {
    name: 'My Chemical Romance',
    img: mcr,
  },
  {
    name: '30 Seconds To Mars',
    img: thirtySTM,
  },
  {
    name: 'Evanescence',
    img: evanescence,
  },
  {
    name: 'Fresno',
    img: fresno,
  },
  {
    name: 'Linking Park',
    img: lp,
  },
  {
    name: 'Nx Zero',
    img: nxZero,
  },
  {
    name: 'Paramore',
    img: paramore,
  },
  {
    name: 'Simple Plan',
    img: simplePlan,
  },
  {
    name: 'The Used',
    img: theUsed,
  },
  {
    name: 'The Strokes',
    img: theStrokes,
  },

];

export default avatars;
